import { combineReducers } from 'redux'
import billetFilters from './billetFilters'
import unities from './unities'

export default combineReducers({
  billetFilters,
  unities
})
